import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapSearchInputComponent } from './google-map-search-input/google-map-search-input.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '../../primeng.module';
import { MaterialModule } from '../../material.module';
import { LocationToStringPipe } from '../../pipes/location-to-string.pipe';



@NgModule({
  declarations: [
    GoogleMapSearchInputComponent
  ],
  providers: [
    LocationToStringPipe
  ],
  imports: [
    CommonModule,
    GoogleMapsModule,
    FormsModule,
    PrimengModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:
  [
    GoogleMapSearchInputComponent
  ]
})
export class GoogleMapSearchModule { }
